import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetDepartments } from "../../../store/department-store/department-actions";
import ABADatatable from "../../../components/ABADatatable";
import { departmentActions } from "../../../store/department-store/department-slice";
import { Button } from "primereact/button";

const DepartmentHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const department = useSelector((state) => state.department);
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.roles !== undefined && auth.roles.includes("department.showAll")) {
      dispatch(GetDepartments(auth.UserInfo.email, true, true));
    }
  }, [dispatch, auth]);

  const viewDetailHanlder = (val) => {
    navigate(`/department/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/department/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      departmentActions.setDepartment({
        department: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/department/create`);
  };
  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (auth.roles !== undefined && auth.roles.includes("department.edit")) {
      buttons.push(buttonEdit);
    }
    if (auth.roles !== undefined && auth.roles.includes("department.view")) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];
  return (
    <>
      <ABADatatable
        width="20%"
        title="Departamentos"
        values={department.departments}
        rows={5}
        rowsPerPageOptions={[5, 10, 20]}
        Columns={columns}
        actions={actions}
        createButton={{
          label: "Crear Departamento",
          onClick: createHanlder,
          permission: "department.create",
        }}
        backButton={{
          label: "Regresar",
          onClick: backHanlder,
          permission: "goBack",
        }}
      />
    </>
  );
};
export default DepartmentHomePage;
